<div class="upload-dialog">
  <!-- Header -->
  <div class="dialog-header">
    <div class="header-content">
      <div class="header-icon">
        <i class="fa-solid fa-cloud-arrow-up"></i>
      </div>
      <div class="header-text">
        <h2>Upload Files</h2>
        <p>Upload your CSV files for classification</p>
      </div>
    </div>
  </div>

  <mat-dialog-content *ngIf="!isUploading" class="dialog-content">
    <!-- Upload Area -->
    <div class="upload-section">
      <div class="upload-container" [class.dragover]="isDragOver" (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
        <div class="upload-content">
          <div class="upload-icon-container">
            <i class="fa-solid fa-cloud-arrow-up upload-main-icon"></i>
          </div>
          <div class="upload-text">
            <h3>Drop your files here</h3>
            <p>or click to browse</p>
          </div>
          <div class="upload-actions">
            <label class="browse-button">
              <i class="fa-solid fa-folder-open"></i>
              Browse Files
              <input type="file" accept=".csv" (change)="onFileSelect($event)" multiple hidden />
            </label>
          </div>
          <div class="upload-info">
            <span><i class="fa-solid fa-info-circle"></i> Only CSV files are supported</span>
          </div>
        </div>
      </div>

      <!-- Error Message -->
      @if (error) {
      <div class="error-message">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span>{{ error }}</span>
      </div>
      }
    </div>

    <!-- Uploaded Files Section -->
    @if (allFiles && allFiles.length > 0) {
    <div class="files-section">
      <div class="section-header">
        <h3>
          <i class="fa-solid fa-file-lines"></i>
          Uploaded Files ({{ allFiles.length }})
        </h3>
      </div>
      <div class="files-container">
        @for (item of allFiles; track $index) {
        <div class="file-card">
          <div class="file-info">
            <div class="file-icon">
              <i class="fa-solid fa-file-csv"></i>
            </div>
            <div class="file-details">
              <div class="file-name">{{ item.name }}</div>
              <div class="file-size">{{ formatFileSize(item.size) }}</div>
            </div>
          </div>
          <div class="file-actions">
            <button class="remove-btn" (click)="removeFile($index)" title="Remove file">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>
        }
      </div>
    </div>
    }

    <!-- Custom Instructions Section -->
    <div class="instructions-section">
      <div class="section-header">
        <h3>
          <i class="fa-solid fa-message"></i>
          Custom Instructions
        </h3>
        <span class="optional-badge">Optional</span>
      </div>
      <div class="instructions-container">
        <mat-form-field appearance="outline" class="custom-textarea">
          <mat-label>Add specific instructions for classification</mat-label>
          <textarea matInput name="questionText" maxlength="200" rows="3"
            placeholder="e.g., Focus on technical documentation" [(ngModel)]="customInstructions">
</textarea>
          <mat-hint>{{ customInstructions.length || 0 }}/200 characters</mat-hint>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>

  <!-- Footer Actions -->
  <mat-dialog-actions *ngIf="!isUploading" class="dialog-actions">
    <div class="actions-container">
      <button mat-stroked-button class="cancel-btn" (click)="onCancel()">
        <i class="fa-solid fa-xmark"></i>
        Cancel
      </button>
      <button mat-raised-button class="primary-btn" [disabled]="!allFiles || allFiles.length === 0"
        (click)="validateAndGenerate()">
        <i class="fa-solid fa-play"></i>
        Validate & Generate
      </button>
    </div>
  </mat-dialog-actions>

  <div *ngIf="isUploading" class="loader">
    <div class="loader-circle-11">
      <div class="arc"></div>
      <div class="arc"></div>
      <div class="arc"></div>
    </div>
    <br />
    <div class="loader-message">File is uploading & generating classification. This may take a while (2-3 minutes).
    </div>
  </div>
</div>